import { QueryPageResult, RuntimeModel, http } from '@kunlun/dependencies';

export interface IWorkbookModel {
  id: string;
  name: string;
  displayName: string;
  sheetDefinitions: string;
}

/**
 * 获取导入模板url
 *
 * @export
 * @param {RuntimeModel} rModel
 * @param {*} id
 * @return {*}
 */
export async function getImportTemplateUrl(rModel: RuntimeModel, id) {
  const gql = `
   {
    excelWorkbookDefinitionQuery {
      fetchImportTemplateUrl(data: {id: ${id}}) {
        redirectUri
      }
    }
  }
  `;

  const res = await http.mutate<{ redirectUri: string }>(rModel.moduleName, gql);
  return res.data.excelWorkbookDefinitionQuery.fetchImportTemplateUrl;
}

/**
 * 查询导入导出模板
 *
 * @export
 * @param {RuntimeModel} rModel
 * @param {boolean} [isExport=false]
 * @param {string} [importTemplateName]
 * @return {*}
 */
export async function queryWorkbook(rModel: RuntimeModel, isExport = false, importTemplateName?: string) {
  const scene = isExport ? 'EXPORT' : 'IMPORT';
  // 支持逗号分隔的多模板名称，使用 RSQL =in= 语法查询
  let nameFilter = '';
  if (importTemplateName) {
    if (importTemplateName.includes(',')) {
      const names = importTemplateName
          .split(',')
          .map((n) => `'${n.trim()}'`)
          .join(',');
      nameFilter = `and name =in= (${names})`;
    } else {
      nameFilter = `and name == '${importTemplateName}'`;
    }
  }
  const query = `{
    excelWorkbookDefinitionQuery{
      queryPage(page: {size: 20}, queryWrapper: {rsql: "model == '${
      rModel.model
  }' and dataStatus == 'ENABLED' and type =in= ('IMPORT_EXPORT','${scene}') ${
      nameFilter
  }"}) {
          content {
            id
            name
            displayName
            sheetDefinitions
          }
          size
          totalPages
          totalElements
        }
      }
  }`;

  const res = await http.query<QueryPageResult<IWorkbookModel>>(rModel.moduleName, query);
  return res.data.excelWorkbookDefinitionQuery.queryPage;
}
